import axios from 'axios'
import { TreeNode, Namespace, SparqlVariable, TreeRequestBody, Ontology, Concept, ConceptRequest } from '../model/models'
import main from '../main'

class SparqlService {
  public namespaces:Namespace[] = []
  public serverUrl = ''
  supportedTypes:string[] = ['resource','vocabularies','bibliography']

  constructor () {
    if (process.env.NODE_ENV === 'development') {
      this.serverUrl = 'http://127.0.0.1:8080'
    }
  }


  // return the name of the url
  public extractConceptFromId(id:string):string {

    var fields = id.split("/")

    var concept  = ''
    if (fields.length > 5) concept = fields[5]
    if (fields.length > 6) concept +='/' + fields[6]
    if (fields.length > 7) concept +='/' + fields[7]
    if (fields.length > 8) concept +='/' + fields[8]
    return concept
  }

  gotoConcept (router:any, id:string) {
    // indicate to ConceptPane that it is an internal request
    main.store.commit('externalRequest',false)
    var fields = id.split("/")
    var type = fields[3]
    var ontology = fields[4]

    var concept  = fields[5]
    if (fields.length > 6) concept +='/' + fields[6]
    if (fields.length > 7) concept +='/' + fields[7]
    if (fields.length > 8) concept +='/' + fields[8]

    if (this.supportedTypes.indexOf(type) >= 0) {  
      console.log('goto concept -- ', type, ' -- ',ontology, ' -- ' , concept)  
      router.push({
          name: 'concept',
          params: {
            type: type,
            ontology: ontology,
            concept: concept
          }
      })
      this.getConceptAsync(ontology, id)
    } else {
        console.log('Open extra tab for:', id)  
        window.open(id, '_blank')
    }
  }

  getSkosTreeAsync (){
    var ontology:Ontology = main.store.getters.ontology 
    var rootUrl:string = ontology.namespace
    console.log('getSkosTreeAsync namespace: ', rootUrl)

    main.store.commit('resetSkosRoot', rootUrl)
    main.store.commit('setSkosRootLabel', ontology.name)

    var skosRoot = main.store.getters.skosRoot
    this.getTreenodeChildrenAsync(skosRoot,'skosroot')
  }
  getClassTreeAsync (){
    var ontology:Ontology = main.store.getters.ontology   
    var rootUrl:string = ontology.namespace
    console.log('getClassTreeAsync namespace: ', rootUrl)

    main.store.commit('resetClassRoot', rootUrl)
    main.store.commit('setClassRootLabel', ontology.name)

    var classRoot = main.store.getters.classRoot
    this.getTreenodeChildrenAsync(classRoot,'classroot')
  }

  getClassChildrenAsync (parent:TreeNode) {
    this.getTreenodeChildrenAsync(parent,'classnode')
  }

  getSkosChildrenAsync (parent:TreeNode) {
    this.getTreenodeChildrenAsync(parent,'skosnode')
  }

  getTreenodeChildrenAsync (parent:TreeNode, method:string) {
    var lang:string = main.store.getters.language
    console.log('getTreenodeChildrenAsync for node:',parent.label, ' language:', lang)

    var body = new TreeRequestBody(parent.url, lang)
    parent.icon = 'refresh'
    parent.collapsed = false  
    main.store.commit ('busy', true)
    axios({
      method   :'post',
      url      : this.serverUrl + '/tree/' + method + '/',
      data     : body
    }).then((resp) => {
      parent.resolved = true
      // collapsed is false otherwise root will not be visible
      var response = resp.data
      if ( response.data){
        // note that data is a list of sparql variables
        for (var n of response.data){
          let node = {
            label: n.label , //this.prefixWithNamespace(n),
            url: n.id,
            prefixId:n.prefixId,
            icon: 'fa fa-angle-right',
            children: [],
            resolved: false,
            collapsed: true,
            isRoot: false,
            isLeaf: false
          }
          parent.children.push(node)
        }
        if (response.data.length === 0){
          parent.icon ='fa fa-angle-left'   
          parent.isLeaf = true  
          parent.collapsed = true     
        } else {
          parent.icon = 'fa fa-angle-down' 
          parent.isLeaf = false  
          parent.collapsed = false    
        }
      }
      main.store.commit ('busy', false)
    }).catch((err) => {
      this.error(err)
    })    
  }

  public getSearchPromise(query:string){
    console.log('getSearchPromise Qeuery',query)
    return axios({
      method   :'post',
      url      : this.serverUrl + '/rdfproxy/',
      data     : { method:"query", query: query }
    })   
  }

  getOntologiesAsync () {
    var lang:string = main.store.getters.language
    console.log('getOntologiesAsync language: ', lang)

    main.store.commit ('busy', true)
    axios({
      method   :'get',
      url      : this.serverUrl + '/ontologies/query?lang=' + lang
    }).then((resp) => {
      var response = resp.data
      if (response.data){
        var ontologies:Ontology[] = response.data.ontologies
        main.store.commit ('ontologies', ontologies)

      }
      main.store.commit ('busy', false)
    }).catch((err) => {
      this.error(err)
    })    
  }
  getOntologyAsync (id:string) {
    var lang:string = main.store.getters.language
    // replace all dots with %2e
    id = id.replace(/\./g, "-dot-"); 

    console.log('getOntologyAsync:' ,id, ' language: ', lang)

    main.store.commit ('busy', true)
    axios({
      method   :'get',
      url      : this.serverUrl + '/ontologies/ontology/' + id + '?lang=' + lang
    }).then((resp) => {
      var response = resp.data
      if (response.data){
        var ontology:Ontology= response.data
        main.store.commit ('ontology', ontology)
      }
      main.store.commit ('busy', false)
    }).catch((err) => {
      this.error(err)
    })    
  }
  getConceptAsync (ontologyId:string, conceptId:string) {
    var lang:string = main.store.getters.language

    // reset current concept
    var sv = new SparqlVariable()
    var emptyconcept = new Concept()
    emptyconcept.concept = sv
    main.store.commit ('concept', emptyconcept)

    var request = new ConceptRequest()
    request.id = conceptId
    request.ontologyId = ontologyId
    request.lang = lang
    main.store.commit ('busy', true)
    axios({
      method   :'post',
      url      : this.serverUrl + '/concept/',
      data     : request
    }).then((resp) => {
      var response = resp.data
      if (response.data){
        var concept:Concept = response.data
        main.store.commit ('concept', concept)
      }
      main.store.commit ('busy', false)
    }).catch((err) => {
      this.error(err)
    })    
  }

  searchConceptAsync (ontology:Ontology|null, search:string) {
    var lang:string = main.store.getters.language
    console.log('searchConceptAsync language: ', lang)

    var url = this.serverUrl + '/search/concept'+ '?concept=' + search +'&lang=' + lang
    if (ontology && ontology.id != '') url += '&ontology='+ontology.id

    main.store.commit ('busy', true)
    axios({
      method   :'get',
      url      : url
    }).then((resp) => {
      var response = resp.data
      if (response.data){
        var results:SparqlVariable[] = response.data
        console.log('results:', results)
        results.forEach(s => {
          if (!s.label) s.label = s.prefixId
        })
        main.store.commit ('searchResult', results)
      }
      main.store.commit ('busy', false)
    }).catch((err) => {
      this.error(err)
    })    
  }


  error(message:string){
    main.store.commit ('busy', false)
    main.store.commit ('errorMessage', message)
    console.log(message)
  }  
}

var sparqlService = new SparqlService()
export default sparqlService 


// WEBPACK FOOTER //
// ./src/service/SparqlService.ts